import { useStrings } from "@1js/localization-components";
import { Button, Text } from "@fluentui/react-components";
import parse from "html-react-parser";
import React from "react";
import useTelemetry from "../../utils/Telemetry/useTelemetry";
import {
  SignIn,
  SignInButtonLabel,
  SignInTextPromptDetail,
} from "../SignInHeader/SignInHeader.web.string";
import { SignInHeaderNavStyles } from "./PromptDetailSignIn.styles";

const useStyles = SignInHeaderNavStyles;

const PromptDetailSignIn: React.FC<{ promptId: string }> = ({ promptId }) => {
  const styles = useStyles();
  const telemetry = useTelemetry();
  const localizations = useStrings({
    SignIn,
    SignInButtonLabel,
    SignInTextPromptDetail,
  });

  const handleClick = () => {
    telemetry.sendSignInPromptClickEvent();
  };

  const searchParams = window.location.search
    ? window.location.search + `&promptId=${promptId}`
    : `?promptId=${promptId}`;

  const returnLink = encodeURIComponent(
    `https://${window.location.host}/prompts/all${searchParams}`
  );
  const link = `https://${window.location.host}/authentication/signin?ru=${returnLink}`;

  return (
    <div className={styles.main} data-testid="prompt-detail-sign-in">
      <Text data-testid="sign-in-text" className={styles.text}>
        {parse(localizations.SignInTextPromptDetail())}
      </Text>
      <Button
        data-testid="sign-in-button"
        size={"small"}
        appearance={"secondary"}
        as="a"
        onClick={handleClick}
        href={link}
        aria-label={localizations.SignInButtonLabel()}
      >
        <Text>{parse(localizations.SignIn())}</Text>
      </Button>
    </div>
  );
};

export default PromptDetailSignIn;
